/** Theme colour scheme identifiers (matches MUI's `useColorScheme` `mode`). */
export const COLOR_SCHEME = {
  LIGHT: 'light',
  DARK: 'dark',
  SYSTEM: 'system',
} as const;
